"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSvdexElbowCorrection = void 0;
var gl_matrix_1 = require("gl-matrix");
var geometryTransformer_1 = require("./geometryTransformer");
// This compiled SVDEX has a reversed right upper-arm basis and rigid elbow rings.
// Keep the asset repair outside the GoldSrc animation decoder.
var createSvdexElbowCorrection = function (model, bodyPartIndex, subModelIndex, vertices, indices) {
    if (model.header.name !== 'v_svdex.mdl' || model.header.length !== 1064740)
        return;
    var subModel = model.subModels[bodyPartIndex][subModelIndex];
    if (!['JUNE_CSO_VIP_HAND_REF', 'CSO_Hand_Female_L_2009'].includes(subModel.name))
        return;
    var vertexBones = model.vertBoneBuffer[bodyPartIndex][subModelIndex];
    var repairs = [];
    var _loop_1 = function (name_1, parentName) {
        var boneIndex = model.bones.findIndex(function (bone) { return bone.name === name_1; });
        if (boneIndex < 0)
            return "continue";
        var bone = model.bones[boneIndex];
        if (!model.bones[bone.parent] || model.bones[bone.parent].name !== parentName)
            return "continue";
        var shoulderZ = Infinity;
        var elbowZ = Infinity;
        var _loop_2 = function (i) {
            var touchesForearm = [0, 1, 2].some(function (j) { return vertexBones[indices[i + j]] === bone.parent; });
            for (var j = i; j < i + 3; j++) {
                if (vertexBones[indices[j]] !== boneIndex)
                    continue;
                shoulderZ = Math.min(shoulderZ, vertices[j * 3 + 2]);
                if (touchesForearm)
                    elbowZ = Math.min(elbowZ, vertices[j * 3 + 2]);
            }
        };
        for (var i = 0; i < indices.length; i += 3) {
            _loop_2(i);
        }
        if (!Number.isFinite(elbowZ) || elbowZ <= shoulderZ)
            return "continue";
        // In this asset the default local transform preserves the elbow's connection
        // to its forearm. Blend only the elbow-side 45% of the upper arm toward it.
        var reference = gl_matrix_1.mat4.fromRotationTranslation(gl_matrix_1.mat4.create(), (0, geometryTransformer_1.anglesToQuaternion)(gl_matrix_1.vec3.fromValues(bone.value[3], bone.value[4], bone.value[5])), gl_matrix_1.vec3.fromValues(bone.value[0], bone.value[1], bone.value[2]));
        var transition = (elbowZ - shoulderZ) * 0.45;
        for (var i = 0; i < indices.length; i++) {
            if (vertexBones[indices[i]] !== boneIndex)
                continue;
            var offset = i * 3;
            var local = gl_matrix_1.vec3.fromValues(vertices[offset], vertices[offset + 1], vertices[offset + 2]);
            var anchored = gl_matrix_1.vec3.transformMat4(gl_matrix_1.vec3.create(), local, reference);
            var t = Math.max(0, Math.min(1, (local[2] - elbowZ + transition) / transition));
            if (name_1 === 'Bone_R_Upper') {
                // Rx(pi) in bone-local coordinates, before the animated world transform.
                local[1] = -local[1];
                local[2] = -local[2];
            }
            repairs.push({ offset: offset, boneIndex: boneIndex, parentIndex: bone.parent, local: local, reference: anchored, weight: t * t * (3 - 2 * t) });
        }
    };
    for (var _i = 0, _a = [['Bone_L_Upper', 'Bone01'], ['Bone_R_Upper', 'Bone04']]; _i < _a.length; _i++) {
        var _b = _a[_i], name_1 = _b[0], parentName = _b[1];
        _loop_1(name_1, parentName);
    }
    if (repairs.length === 0)
        return;
    var upper = gl_matrix_1.vec3.create();
    var elbow = gl_matrix_1.vec3.create();
    return function (positions, transforms) {
        for (var _i = 0, repairs_1 = repairs; _i < repairs_1.length; _i++) {
            var vertex = repairs_1[_i];
            gl_matrix_1.vec3.transformMat4(upper, vertex.local, transforms[vertex.boneIndex]);
            gl_matrix_1.vec3.transformMat4(elbow, vertex.reference, transforms[vertex.parentIndex]);
            gl_matrix_1.vec3.lerp(upper, upper, elbow, vertex.weight);
            positions.set(upper, vertex.offset);
        }
    };
};
exports.createSvdexElbowCorrection = createSvdexElbowCorrection;
